import type {CustomerProfileLifecycleBase} from "~/components/entityProfile/customerProfileDataSource/types";
import type {CustomerProfileLifecycleOption} from "~/components/entityProfile/customerProfileDataSource/types";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

/** Maps customer lifecycles to filter options; links the active lifecycle to the customer's event container when present. */
export function buildCustomerProfileLifecycleOptions(args: {
    lifecycles: Array<Pick<CustomerProfileLifecycleBase, "id" | "title" | "status">>;
    linkedEventContainerId: Uuid | null;
    linkedEventContainerTemplateId: Uuid | null;
}): Array<CustomerProfileLifecycleOption> {
    const activeLifecycleId = args.lifecycles.find((lifecycle) => lifecycle.status === "active")?.id ?? null;

    return args.lifecycles.map((lifecycle) => ({
        id: lifecycle.id as Uuid,
        label: lifecycle.title,
        eventContainerId:
            lifecycle.id === activeLifecycleId && args.linkedEventContainerId !== null
                ? args.linkedEventContainerId
                : null,
        eventContainerTemplateId:
            lifecycle.id === activeLifecycleId && args.linkedEventContainerId !== null
                ? args.linkedEventContainerTemplateId
                : null,
    }));
}

export function resolveDefaultCustomerProfileLifecycleId(
    options: Array<CustomerProfileLifecycleOption>,
): Uuid | null {
    if (options.length === 0) {
        return null;
    }
    const withEventContainer = options.find((option) => option.eventContainerId !== null);
    if (withEventContainer !== undefined) {
        return withEventContainer.id;
    }
    return options[0]?.id ?? null;
}
